import React from "react";
import {useGetAndSet} from "./useGetAndSet";
import {useDispatch} from "react-redux";
import {useHttp} from "./useHttp";
import {createSetMovementDataAction} from "../actions/dataActions";


export const useMovementData = (id, dataFresh) => {
    let noFetch = !id
    const dispatch = useDispatch();
    const [data, loading, error] = useHttp(
        `movement/${id}`,
        "get",
        {},
        dataFresh,
        noFetch
    );
    if(error){
        throw Error("There was an error getting movement data");
    }
    if(!loading && data !== null){
        dispatch(createSetMovementDataAction(data));
    } else {
        dispatch(createSetMovementDataAction({
            customer: {},
            customer_vehicle : "",
            customer_vehicle_vin: "",
            parts: [],
            status: "ORDER",
            description: "",
            department: {name:"RAPID FIT", id:5}
        }))
    }

    return !loading
}